import React from 'react';

export default function PageHeading({ title, children }) {
  return (
    <div className='workspace-page-heading'>
      <h1>{title}</h1>
      {children && <div className='workspace-heading-actions'>{children}</div>}
    </div>
  );
}
